const CONTAINER_FINAL_QUALITY_STATUSES = {
  rejected: {
    id: 0,
    key: "rejected",
    color: "red"
  },
  medium_quality: {
    id: 1,
    key: "medium_quality",
    color: "yellow"
  },
  high_quality: {
    id: 2,
    key: "high_quality",
    color: "green"
  }
};

export default {
  computed: {
    containerFinalQualityStatuses() {
      return Object.values(CONTAINER_FINAL_QUALITY_STATUSES);
    }
  },
  methods: {
    qualityStatusKey(status_id) {
      return this.containerFinalQualityStatuses.find(
        status => status.id == status_id
      )?.key;
    },
    qualityStatusColor(status_id) {
      return this.containerFinalQualityStatuses.find(
        status => status.id == status_id
      )?.color;
    },
    qualityStatusIsRejected(status_id) {
      return CONTAINER_FINAL_QUALITY_STATUSES.rejected.id == status_id;
    },
    qualityStatusIsMediumQuality(status_id) {
      return CONTAINER_FINAL_QUALITY_STATUSES.medium_quality.id == status_id;
    },
    qualityStatusIsHighQuality(status_id) {
      return CONTAINER_FINAL_QUALITY_STATUSES.high_quality.id == status_id;
    }
  }
};
